import Model from './Model'

export default class SubelementModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'subelements'
  }
}
